export default class {
  constructor () {
    if (typeof window.Livewire === 'undefined') {
      throw 'window.Livewire is undefined. Make sure to include the Livewire scripts before this script';
    }
  }

  cacheLivewireComponents() {
    // Livewire 3 keeps component state in wire:snapshot attributes within the
    // fetched HTML, so nothing needs to be cached before a page transition.
  }

  destroyLivewireComponents(container) {
    // Tear down Livewire/Alpine state inside `container` before its HTML is
    // swapped out. Alpine's MutationObserver only cleans up removed nodes it
    // has itself initialised (stamped with `_x_marker`), and on a hard page
    // load it only initialises component roots — so the server-rendered
    // <main> wrapping a component is never stamped, and removing it via
    // innerHTML leaves that component registered in Livewire's store forever.
    // Statically cached pages always render the same wire:id, so when that
    // page is swapped back in (e.g. via the back button), Livewire sees the
    // id as already registered and skips initialising it — which for a lazy
    // component means its placeholder never loads. Destroying the tree
    // explicitly runs the wire:id cleanup and unregisters the component.
    if (container && window.Alpine && typeof window.Alpine.destroyTree === 'function') {
      window.Alpine.destroyTree(container)
    }
  }

  refreshLivewireComponents() {
    // Boot any components introduced by the swapped-in HTML.
    if (typeof window.Livewire.rescan === 'function') {
      window.Livewire.rescan()
    } else if (typeof window.Livewire.restart === 'function') {
      window.Livewire.restart()
    }
  }

}
